import { userHasMembership } from 'src/utils/userMembership'
import { useMyInfo } from '../apollo/auth'

export function useMe() {
  const { data: me, ...rest } = useMyInfo()

  return {
    me,
    beingAdmin: Boolean(me?.isAdmin),
    beingMember: userHasMembership(me),
    membershipTier: me?.membership?.tier,
    ...rest,
  }
}
